import { render } from "./DepartSelect.vue?vue&type=template&id=41d7693b"
import script from "./DepartSelect.vue?vue&type=script&lang=js"
export * from "./DepartSelect.vue?vue&type=script&lang=js"
script.render = render

export default script